module.exports = __webpack_public_path__ + "img/DCIImg07.59e199d9.png";